angular.module 'zc.commonApi'

.factory "MongoCampaign", ($q, FacadeV2) ->

  class MongoCampaign

    @find: (query, options = {}) ->
      $q (resolve, reject) ->
        query ||= {}

        unless query.apikey
          return reject "No apikey"

        # indexes are apikey_1_created_at_1 and any id
        unless query._id or query._sid or query._uuid or query._usid or query.campaign_id or query.created_at
          return reject "no _id or _sid or _uuid or _usid or campaign_id"

        FacadeV2.request "/apikeys/#{query.apikey}/campaigns",
          params:
            match: query
            sort: options.sort
            fields: options.fields
            limit: options.limit || 1000
        .then (res) ->
          if res.status != 200 || res.data.error
            reject res.data.error
          else
            resolve res.data

  MongoCampaign



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/facade/mongo_campaign.service.coffee